// extracted by mini-css-extract-plugin
export var deliveryRow = "_rh-a";
export var fixedHeight = "_rh-4";
export var freightLogo = "_rh-9";
export var fullWidth = "_rh-3";
export var priceColumn = "_rh-5";
export var radioSelected = "_rh-7";
export var radioUnselected = "_rh-6";
export var selectedOption = "_rh-2";
export var selectedOptionContainer = "_rh-1";
export var selection = "_rh-0";
export var tallSkeletonText = "_rh-8";